import { render, staticRenderFns } from "./paishui.vue?vue&type=template&id=7deabe8c&scoped=true&"
import script from "./paishui.vue?vue&type=script&lang=js&"
export * from "./paishui.vue?vue&type=script&lang=js&"
import style0 from "./paishui.vue?vue&type=style&index=0&id=7deabe8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deabe8c",
  null
  
)

export default component.exports